import { useEffect } from 'react'

const ClassRedirect = () => {
  useEffect(() => {
    window.location.href =
      'https://cti.formstack.com/forms/cti_regional_training_form'
  }, [])

  return null
}

export default ClassRedirect
